module.exports = __webpack_public_path__ + "img/public/SiteIcons/steeringIcon.svg?beeec3d3";